import { CAIP2 } from "@paywithglide/glide-js";

export function filterPaymentChainIds(
  allowedChainIds: CAIP2[] | undefined,
  availableChainIds: CAIP2[] | undefined,
  excludeChainIds?: CAIP2[],
) {
  let filtered: CAIP2[] | undefined;

  if (allowedChainIds?.length) {
    // If we have an allowlist, filter available chains by it
    // If availableChainIds is undefined (wallet not connected yet), use allowlist directly
    filtered = availableChainIds
      ? availableChainIds.filter((id) => allowedChainIds.includes(id))
      : allowedChainIds;
  } else {
    // No allowlist - use all available chains
    filtered = availableChainIds;
  }

  // Remove excluded chains
  if (excludeChainIds?.length && filtered) {
    filtered = filtered.filter((id) => !excludeChainIds.includes(id));
  }

  return filtered;
}
